// extracted by mini-css-extract-plugin
module.exports = {"winnersText":"RoundOverModule_winnersText__3Jqiy","blackIcon":"RoundOverModule_blackIcon__oHhnF","divider":"RoundOverModule_divider__1EcJP"};